// extracted by mini-css-extract-plugin
export default {"form":"form---O5li_","footer":"footer---ltdMm"};